import type { ExpressionSpecification } from "mapbox-gl";

import { OrthoApprovalStatus } from "api/model";

/** Anything outside the grid being drawn recedes so the draft stays legible. */
export const DIM_FACTOR = 0.3;

/** Background for a selected ortho, grower, or site in the map UI. */
export const SELECTED_MAP_ITEM_BGCOLOR = "success.light";

/** Square left edge on a selected grower boundary. */
export const SELECTED_MAP_ITEM_BORDER_COLOR = "success.dark";

/** Applies {@link DIM_FACTOR} to features carrying a truthy `dimmed` property. */
export const dimmedOpacity = (baseOpacity: number): ExpressionSpecification => [
  "case",
  ["get", "dimmed"],
  baseOpacity * DIM_FACTOR,
  baseOpacity,
];

export const COLORED_PLOT_FILL_OPACITY = 0.55;
export const DEFAULT_PLOT_FILL_COLOR = "#00e5ff";
export const DEFAULT_PLOT_FILL_OPACITY = 0.12;
export const SELECTED_PLOT_FILL_COLOR = "#00bcd4";

export const plotFillColor = (
  honorSelection = false,
): ExpressionSpecification => {
  const coloredOrDefault: ExpressionSpecification = [
    "case",
    ["has", "fillColor"],
    ["get", "fillColor"],
    DEFAULT_PLOT_FILL_COLOR,
  ];
  if (!honorSelection) {
    return coloredOrDefault;
  }
  return [
    "case",
    ["get", "selected"],
    SELECTED_PLOT_FILL_COLOR,
    coloredOrDefault,
  ];
};

export const getOrthoStatusChipSettings = (
  status: OrthoApprovalStatus,
): {
  color: "error" | "info" | "primary" | "success" | "warning";
  label: string;
} => {
  switch (status) {
    case OrthoApprovalStatus.approved:
      return { color: "success", label: "Approved" };
    case OrthoApprovalStatus.pending:
      return { color: "warning", label: "Pending" };
    case OrthoApprovalStatus.processing:
      return { color: "info", label: "Processing" };
    case OrthoApprovalStatus.rejected:
      return { color: "error", label: "Rejected" };
    case OrthoApprovalStatus.uploading:
      return { color: "primary", label: "Uploading" };
  }
};
